module.exports = __webpack_public_path__ + "static/surroundings-3@2x-0864dd0eaac70db9b2175e5cb5e85207.jpg";